/**
 * useTour — context hook for the guided in-app tour (#1559)
 *
 * Extracted from TourProvider.tsx to satisfy `react-refresh/only-export-components`.
 * The provider component lives in TourProvider.tsx; this module owns the context
 * + consumer hook so providers and consumers can be re-imported independently
 * without breaking React fast refresh.
 */

import { createContext, useContext } from 'react';

export interface TourContextValue {
  /** Tour is currently running. */
  isActive: boolean;
  /** User has completed or dismissed the tour at least once. */
  hasCompleted: boolean;
  /** Start the tour (used by TourPrompt and Settings → Replay). */
  start: () => void;
  /** Mark tour as dismissed without starting (Tour Prompt → "No thanks"). */
  dismiss: () => Promise<void>;
  /** Target identifier of the current step (e.g. 'chat-rooms-list'), or null when not running. */
  currentStepTarget: string | null;
}

export const TourContext = createContext<TourContextValue | null>(null);

export function useTour(): TourContextValue {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used within TourProvider');
  return ctx;
}
